<div class="error-tile">
    <div class="content-column"><div class="access-error-img"></div></div>
    <div class="content-column">
        <div class="error-header-string">Access Restricted</div>
        <div class="error-message">You do not have the necessary permissions to view this page.</div>
        <div class="error-contact">Please contact your Tenant Manager or Ignite UI Admin for help.</div>
    </div>
    <hr />
    <div class="error-button-container">
        <div class="error-button" [routerLink]="['/']">Go to homepage</div>
    </div>
</div>
